
@if (isCompactView()) {
  <span class="text-fixed-medium color-black w-100 text-right d-block mt-4">
    {{ orders().length || '' }} {{'ordersList.mostRecentOrders' | cxTranslate }}
  </span>
}
<div class="sanofi-orderHistoryTable container" [class.sanofi-orderHistoryTable--compact]="isCompactView()">
    <section class="sanofi-orderHistoryTable__header row py-4 my-3 font-weight-bold d-none d-lg-flex">
      <div class="col-12 sanofi-orderHistoryTable__orderTableCol" (click)="sortColumn($event, 'placed', orders(), 'Date')">
        {{ 'ordersList.date' | cxTranslate }}
        <i class="ml-1 my-icon fas fa-caret-down"></i>
      </div>
      <div class="col-12 sanofi-orderHistoryTable__orderTableCol" (click)="sortColumn($event, 'statusDisplay', orders(), 'normal')">
        {{ 'ordersList.status' | cxTranslate }}
        <i class="ml-1 my-icon fas fa-caret-down"></i>
      </div>
      <div class="col-12 sanofi-orderHistoryTable__orderTableCol" (click)="sortColumn($event, 'guid', orders(), 'Number')">
        {{ 'ordersList.order' | cxTranslate }}
        <i class=" ml-1 my-icon fas fa-caret-down"></i>
      </div>
      <div class="col-12 sanofi-orderHistoryTable__orderTableCol" (click)="sortColumn($event, 'purchaseOrderNumber', orders(), 'normal')">
        {{ 'ordersList.po' | cxTranslate }}
        <i class=" ml-1 my-icon fas fa-caret-down"></i>
      </div>
      @if (!isCompactView()) {
        <div class="col-12 sanofi-orderHistoryTable__orderTableCol">{{ 'ordersList.invoice' | cxTranslate }}</div>
        <div class="col-12 sanofi-orderHistoryTable__orderTableCol">{{ 'ordersList.tracking' | cxTranslate }}</div>
      }
      <div class="col-12 sanofi-orderHistoryTable__orderTableCol" (click)="sortColumn($event, 'shipToId', orders(), 'normal')">
        {{ 'ordersList.shipToId' | cxTranslate }}
        <i class="ml-1 my-icon fas fa-caret-down"></i>
      </div>
    </section>
    <section class="sanofi-orderHistoryTable__body">
      @if (isLoading()) {
        <app-loader/>
      } @else {
        @for (order of orders(); track order.guid) {
          <div class="sanofi-orderHistoryTable__row row py-4 my-3">
            <div class="sanofi-orderHistoryTable__cell col-12 sanofi-orderHistoryTable__orderTableCol justify-content-between py-2 py-lg-0">
              <span class="font-weight-bold d-lg-none col-6">{{ 'ordersList.date' | cxTranslate }}</span>
              <span class="col-6 col-lg-12 px-lg-0">{{ CommonUtils.formatDate(order?.placed, dateFormat().toUpperCase()) }}</span>
            </div>

            <div class="sanofi-orderHistoryTable__cell col-12 sanofi-orderHistoryTable__orderTableCol justify-content-between py-2 py-lg-0">
              <span class="font-weight-bold d-lg-none col-6">{{ 'ordersList.status' | cxTranslate }}</span>
              <span class="col-6 col-lg-12 px-lg-0">{{ [('ordersList.statuses.' + order.status), 'ordersList.missingStatusConfiguration'] | cxTranslate }}</span>
            </div>

            <div class="sanofi-orderHistoryTable__cell col-12 sanofi-orderHistoryTable__orderTableCol justify-content-between py-2 py-lg-0">
              <span class="font-weight-bold d-lg-none col-6">{{ 'ordersList.order' | cxTranslate }}</span>
              <span class="col-6 col-lg-12 px-lg-0">
                   <a class="c-link" [routerLink]="['/my-account/order', order.guid]">{{ order.guid }}</a>
                </span>
            </div>

            <div class="sanofi-orderHistoryTable__cell col-12 sanofi-orderHistoryTable__orderTableCol justify-content-between py-2 py-lg-0">
              <span class="font-weight-bold d-lg-none col-6">{{ 'ordersList.po' | cxTranslate }}</span>
              <span class="col-6 col-lg-12 px-lg-0">{{ getPONumber(order.purchaseOrderNumber) }}</span>
            </div>

            @if (!isCompactView()) {
              <div class="sanofi-orderHistoryTable__cell col-12 sanofi-orderHistoryTable__orderTableCol justify-content-between py-2 py-lg-0">
                <span class="font-weight-bold d-lg-none col-6">{{ 'ordersList.invoice' | cxTranslate }}</span>
                <div class="d-flex flex-column flex-lg-row col-6 col-lg-12 px-lg-0 flex-wrap">
                  @for (invoice of order.invoices; track invoice.invoiceNumber) {
                    <a (click)="generateInvoicePDF(invoice.invoiceNumber)" class="pdf-text c-link mr-lg-1">{{ invoice.invoiceNumber }}</a>
                  }
                </div>
              </div>
              <div class="sanofi-orderHistoryTable__cell col-12 sanofi-orderHistoryTable__orderTableCol justify-content-between py-2 py-lg-0">
                <span class="font-weight-bold d-lg-none col-6">{{ 'ordersList.tracking' | cxTranslate }}</span>
                <div class="d-flex flex-column flex-lg-row col-6 col-lg-12 px-lg-0 flex-wrap">
                  @for (tracking of order.tracking; track tracking.trackingNumber) {
                    @if (tracking?.carrier !== 'YB') {
                      @for (singleTrackingNumber of tracking?.trackingNumber?.split(',') || []; track singleTrackingNumber) {
                        <a class="pdf-text app-navigation-links mr-lg-1" href="unsafe:javascript:void(0)" rel="" type="external"
                           (click)="navigateToTracking(singleTrackingNumber, tracking?.trackingURL, $event)">
                          {{ singleTrackingNumber }}
                        </a>
                      }
                    }
                  }
                </div>
              </div>
            }

            <div class="sanofi-orderHistoryTable__cell col-12 sanofi-orderHistoryTable__orderTableCol justify-content-between py-2 py-lg-0">
              <span class="font-weight-bold d-lg-none col-6">{{ 'ordersList.shipToId' | cxTranslate }}</span>
              <span class="sanofi-orderHistoryTable__underline col-6 col-lg-12 px-lg-0">{{ order.shipToName }}<br/>{{ order.shipToId }}</span>
            </div>
          </div>
        }
      }
    </section>
  </div>
